<template>
  <li
    :class="[
      'menu-wrapper-item',
      icon ? 'd-flex menu-wrapper-item-icon' : '',
      {'menu-border': seperatorBottom},
      {'disabled-item': disabledItem},
      {'invisible-item': !visible},
    ]"
    role="menuitem"
    tabindex="-1"
    @click="emitClick"
    @keyup.enter="emitClick"
    @keyup.space="emitClick"
    @keydown="onKeyDown"
  >
    <template v-if="icon">
      <div :class="['menu-item-ic', icon]" />
      <div class="menu-item-content">
        <slot />
      </div>
    </template>
    <slot v-else />
  </li>
</template>

<script>
export default {
  props: {
    icon: {
      type: [Array, String],
      default: null,
    },
    seperatorBottom: {
      type: Boolean,
      default: false,
    },
    // disabled 1 item theo trạng thái nào đó VD theo mode
    disabledItem: {
      type: [Boolean, Number],
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    emitClick() {
      this.$emit('menu-item-click');
    },
    /**
    * sự kiện bấm phím
    * ndquang1 07.12.2023
    */
    onKeyDown(e) {
      this.$emit('menu-item-key-down', e);
    },
  },
};
</script>
<style lang="scss">
.menu-wrapper-item {
  &.menu-border {
    border-bottom: 1px solid #c1c4cc;
  }
  // &.menu-border::after {
  //   content: '';
  //   width: 100%;
  //   height: 1px;
  //   background: #c1c4cc;
  //   display: block;
  //   position: relative;
  // }
  &.menu-wrapper-item-icon {
    padding: 0 16px 0 6px !important;
    white-space: nowrap;
  }
  .menu-item-ic {
    margin-right: 8px;
  }
  &.disabled-item {
    pointer-events: none;
    color: #afafaf;
  }
  &.invisible-item {
    display: none;
  }
}
</style>
